(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalHeaderDevelopmentWarning', [RfGlobalHeaderDevelopmentWarningFn]);

    /* main header directive */
    function RfGlobalHeaderDevelopmentWarningFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-header-development-warning.template.html',
            controller: 'HeaderDevelopmentWarningController',
            controllerAs: 'vm',
            scope: true
        };
        return directive;
    }
})();